import React from 'react';
import './BlogPost.css';

import logo from '../../images/2021-sommerfest-schm.jpg';

class BlogPost4 extends React.Component {
  render() {
    return (
    <div className="blogpost-outer">
      <div className="blogpost-title">
        <h3 className="blogpost-h3" >Sommerfest Schmäinghook!     -     28. August 2021</h3>
      </div>
      <div className="blogpost-content">
        <div className="blogpost-image">
          <img className="image-fit" alt="Sommerfest Schmäinghook" src={logo}/>
        </div>
        <div className="blogpost-text">
          Nach langer Schützenfestabstinenz durften wir heute wieder wenigstens ein bisschen Schützenplatzluft schnuppern und den Schützenverein Schmäinghook bei seinem diesjährigen Sommerfest begleiten. Darauf ein dreimal kräftiges:
          <p>HORRIDO! HORRIDO! HORRIDO!</p>
        </div>

      </div>
    </div>
    )
  }
}

export default BlogPost4;


// WEBPACK FOOTER //
// ./src/components/blog/BlogPost5.js